import { getFirstEntryVsFirstOrder50Off2026Value } from 'utils/ab-test/abTests';

export type PricingTestGroup = ReturnType<
  typeof getFirstEntryVsFirstOrder50Off2026Value
>;

export const getEntryMethodStickerContent = (pricingTestGroup?: PricingTestGroup) => {
  if (pricingTestGroup === 'TEST') {
    return (
      <>
        <strong>50% off</strong> 1st order
      </>
    );
  }

  return (
    <>
      <strong>50% off</strong> 1st entry
    </>
  );
};
